<template>
	<v-toolbar
	text
	class="grey lighten-3"
  fixed
  style="position:fixed; width:100%; z-index:4"
	>
    <PublishSelectedButton />
    <RemoveFromCollection />
    <DownloadDialog :buttonText="'Download'" :collectionId=collectionId :imageCount=imageCount />
    <EditCollection />
    <SelectAllButton />
	</v-toolbar>
</template>

<script>
	export default {
    name: 'CollectionToolbar',
    props: {
      collectionName: '',
      collectionId: '',
      imageCount: null,
    },
		data: () => ({
      on: false,
			collectiondialog: false,
		})
	};
</script>

